import SoundManager from "../../../../../shared/lib/html5-software-library/src/ranj/audio/SoundManager";
import LanguagePack from "../../../../../shared/lib/html5-software-library/src/ranj/language/LanguagePack";
import LayoutManager from "../../../../../shared/lib/html5-software-library/src/ranj/layout/LayoutManager";
import EventDispatcher from "../../../../../shared/lib/html5-software-library/src/ranj/util/EventDispatcher";
import AppModel from "../../../../../shared/src/ranj/app/core/AppModel";
import AbstractMediator from "../../../../../shared/src/ranj/app/ui/AbstractMediator";

export default class BaseInfoPanelMediator extends AbstractMediator {
    /**
     * 
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LanguagePack} languagePack 
     * @param {LayoutManager} layoutManager 
     * @param {SoundManager} soundManager 
     * @param {AppModel} appModel 
     */
    constructor(target, dispatcher, languagePack, layoutManager, soundManager, appModel) {
        super(target, dispatcher, languagePack, layoutManager, soundManager, appModel);

        this._thisDispatcher = new EventDispatcher();
    }

    initialize() {
        super.initialize();

        this._panel = this._target.contents;
        this._toggle = this.createButton(this._panel.toggle, this._handleToggle.bind(this));

        //block clicks through panel, quick and dirty
        this._target.bg.addEventListener("click", () => { });

        this._openY = 0;
        this._closeY = this._panel.y;

        this._animating = false;
        this._toggle.setSelected(true);

        this._forcingReadAll = false;

        this.close(true);

    }

    destroy() {
        super.destroy();
    }

    addEventListener(type, listener, scope) {
        this._thisDispatcher.addEventListener(type, listener, scope);
    }

    removeEventListener(type, listener) {
        this._dispatcher.removeEventListener(type, listener);
    }

    set enabled(value) {
        this._toggle.setEnabled(value);
    }

    _stopNudges() {
        this.killDelayedCall(this._nudgeTimeout);
        this._nudgeTimeout = null;
        if (!!this._nudgeTarget) {
            createjs.Tween.removeTweens(this._nudgeTarget);
            this._nudgeTarget.alpha = 1;
            this._nudgeTarget = null;
        }
    }

    _scheduleNudge(delay = 6000) {
        if (!!this._nudgeTimeout) {
            this.killDelayedCall(this._nudgeTimeout);
        }
        this._nudgeTimeout = this.callDelayed(this._nudge.bind(this), delay / AppModel.speedFactor);
    }

    _nudge() {
        this.killDelayedCall(this._nudgeTimeout);
        this._nudgeTarget = this._panel.toggle;
        this.blink(this._nudgeTarget, 3);
        this._scheduleNudge(8500);
    }

    _nudgeOnce(blinkCount) {
        this.killDelayedCall(this._nudgeTimeout);
        this._nudgeTarget = this._panel.toggle;
        this.blink(this._nudgeTarget, blinkCount);
    }

    blink(target, count = 2) {
        target.alpha = 1;
        const props = { loop: count * 2 - 1, bounce: true };
        createjs.Tween.get(target, props).to({ alpha: 0 }, 500);
    }

    _handleToggle(e) {
        this._stopNudges();
        if (this._state != State.OPENED) {
            this.open();
        } else {
            this.close();
        }
    }

    open(instant = false, useNudge = false) {
        if (this._state != State.OPENED) {
            // NB: when opening set it to be draw on top of its siblings
            this._target.parent.setChildIndex(this._target, this._target.parent.children.length - 1);
            this._animateTo(this._openY, State.OPENED, instant);
            this._thisDispatcher.dispatchEvent(BaseInfoPanelMediator.OPEN);

            if (useNudge) {
                this._scheduleNudge();
            }
        }
    }

    close(instant = false) {
        if (this._state != State.CLOSED) {
            this._animateTo(this._closeY, State.CLOSED, instant);
            this._thisDispatcher.dispatchEvent(BaseInfoPanelMediator.CLOSE);

            this._stopNudges();
        }
    }

    _animateTo(goalY, stateAtEnd, instant) {
        const onComplete = () => {
            this._state = stateAtEnd;
            this._toggle.setSelected(this._state != State.OPENED);
        }
        const alpha = stateAtEnd == State.OPENED ? 1 : 0;
        if (instant) {
            this._panel.y = goalY;
            this._target.bg.alpha = alpha;
            onComplete();
        } else {
            const dur = Math.abs(this._panel.y - goalY) * .5;
            createjs.Tween.get(this._panel).to({ y: goalY }, dur, createjs.Ease.quadOut).call(onComplete);
            createjs.Tween.get(this._target.bg).to({ alpha: alpha }, dur, createjs.Ease.quadOut);
        }
    }

    _setCenteredText(textField, text) {
        if(textField.y0 === undefined || textField.y0 === null) {
            textField.y0 = textField.y;
            textField.height0 = textField.getMeasuredHeight() * textField.scaleY;
        }
        textField.text = text;
        const textHeight = textField.getMeasuredHeight() * textField.scaleY;
        textField.y = textField.y0 + (textField.height0 - textHeight) / 2;
    }
}


const State = { CLOSED: 0, CLOSING: 1, OPENING: 2, OPENED: 3 };

BaseInfoPanelMediator.CLOSE = "InfoPanelView.CLOSE";
BaseInfoPanelMediator.OPEN = "InfoPanelView.OPEN";